<!-- Form element errors for some reason... Seems to work fine without. -->
<!--<form>-->
  <sp-form-element #formElement *ngIf="rootProperty" [formProperty]="rootProperty" [toast]="toast"></sp-form-element>
<!--</form>-->



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/form.component.html